import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import KeypadItem from './keypadItem';
import DTMFGenerator from './dtmfGenerator';
import { colorGrid } from 's2s-themes';
import styled from 'styled-components';

const app = document;

const KeypadContainer = styled.div`
  background-color: ${colorGrid.gray0};
  display: flex;
  flex-direction: column;
  justify-content : space-between;
  padding: 15px 35px;
`;

const KeypadItemsContainer = styled.div`
  display: grid;
  grid-template-rows : 25% 25% 25% 25%;
  grid-template-columns : 33% 33% 33%;
`;

const Keypad = (props) => {
  let ctlActive = false;
  const _DTMFGenerator = DTMFGenerator.getInstance(props.dtmfOutputDeviceId);

  const keyItems = {
    '1': {
      keyString: '',
      keyboardInput: '1'
    },
    '2': {
      keyString: 'ABC',
      keyboardInput: '2AaBbCc'
    },
    '3': {
      keyString: 'DEF',
      keyboardInput: '3DdEeFf'
    },
    '4': {
      keyString: 'GHI',
      keyboardInput: '4GgHhIi'
    },
    '5': {
      keyString: 'JKL',
      keyboardInput: '5JjKkLl'
    },
    '6': {
      keyString: 'MNO',
      keyboardInput: '6MmNnOo'
    },
    '7': {
      keyString: 'PQRS',
      keyboardInput: '7PpQqRrSs'
    },
    '8': {
      keyString: 'TUV',
      keyboardInput: '8TtUuVv'
    },
    '9': {
      keyString: 'WXYZ',
      keyboardInput: '9WwXxYyZz'
    },
    '*': {
      keyString: '',
      keyboardInput: '*'
    },
    '0': {
      keyString: '',
      keyboardInput: '0'
    },
    '#': {
      keyString: '',
      keyboardInput: '#'
    },
    'del': {
      keyboardKeyCode: '8'
    }
  };

  useEffect(() => {
    app.addEventListener('keydown', handleDocumentKeyDown);
    app.addEventListener('keyup', handleKeyUpStop);
    //console.log('useEffect initial fire');

    return function cleanup() {
      app.removeEventListener('keydown', handleDocumentKeyDown);
      app.removeEventListener('keyup', handleKeyUpStop);
      //console.log("useEffect cleanup function fire ");
    };
  }, []);

  const onMouseDown = (keyValue) => {
    // console.log('MouseDown Key Value:', keyValue);
    handlePlay(keyValue);
    handleClick(keyValue);
  };

  const onMouseUp = (keyValue) => {
    // console.log('MouseUp Key Value:', keyValue);
    handleMouseUpStop(keyValue);
  };

  const onMouseLeave = (keyValue) => {
    // console.log('MouseLeave Key Value:', keyValue);
    handleMouseUpStop(keyValue);
  };

  const handleClick = (keyValue) => {
    props.cbKeyPress(keyValue);
  };

  const handlePlay = (keyValue) => {
    // if dtmf tones are disabled, just return
    if (props.disableDTMFTone) {
      return;
    }

    _DTMFGenerator.play(keyValue);
  };

  const handleMouseUpStop = (keyValue) => {
    // if dtmf tones are disabled, just return
    if (props.disableDTMFTone) {
      return;
    }

    _DTMFGenerator.stop(keyValue);
  };

  const handleKeyUpStop = (e) => {
    // if dtmf tones are disabled, just return
    if (props.disableDTMFTone) {
      return;
    }
    // otherwise process the keyup event
    Object.keys(keyItems).forEach((keyValue) => {
      const keyObject = keyItems[keyValue];

      if (e && e.key && keyObject.keyboardInput && keyObject.keyboardInput.indexOf(e.key) > -1) {
        _DTMFGenerator.stop(keyValue);
      }
    });

    if (e && (e.keyCode === 17 || e.keyCode === 91)) {
      ctlActive = false;
    }
  };

  const handleDocumentKeyDown = (e) => {

    // console.warn(e);

    // if dtmf sound is disabled, just return...
    if (props.disableDTMFTone) {
      return;
    }

    // otherwise process the keydown event
    if (e.keyCode === 17 || e.keyCode === 91) {
      ctlActive = true;
    } else if (ctlActive === false) {
      Object.keys(keyItems).forEach((keyValue) => {
        const keyObject = keyItems[keyValue];
        if (keyObject.keyboardInput && keyObject.keyboardInput.indexOf(e.key) > -1) {
          // console.log('key down was called', keyValue);

          // if we are not typoing into DialingInput, hacall handlCli,d

          let classList = e.target.classList.value.split(' ');

          if (classList.indexOf('DialingInput') === -1) {
            handleClick(keyValue);
          }

          handlePlay(keyValue);
        }
      });
    }
  };

  const renderKeyItems = () => {
    const KeyValueArray = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "*", "0", "#"]; //this is done because object.keys was reorganizing the array numerically

    return KeyValueArray.map((keyValue) => {
      const keyObject = keyItems[keyValue];

      return (
        <KeypadItem
          key={keyValue}
          keyValue={keyValue}
          dtmfOutputDeviceId={props.dtmfOutputDeviceId}
          keyString={keyObject.keyString}
          cbMouseDown={onMouseDown}
          cbMouseUp={onMouseUp}
          cbMouseLeave={onMouseLeave}
        />
      );
    });
  };

  return (
    <KeypadContainer className="KeypadContainer" aria-label="Keypad" >
      <KeypadItemsContainer className="KeyItemsContainer" >
        {renderKeyItems()}
      </KeypadItemsContainer>
    </KeypadContainer>
  );
};

Keypad.propTypes = {
  cbKeyPress: PropTypes.func,
  disableDTMFTone: PropTypes.bool,
  dtmfOutputDeviceId: PropTypes.string
};

Keypad.defaultProps = {
  cbKeyPress: () => { console.log('cbKeyPress is not defined'); },
  disableDTMFTone: false,
  dtmfOutputDeviceId: undefined
};


export default Keypad;
